import styled from 'styled-components';
import { selectColor } from '@panel/commons';

const ContentLayout = styled.div`
  border: 1px solid ${selectColor('grayMedium')};
  border-radius: 8px;
  display: flex;
  padding: 12px 14px 14px;
  gap: 10px;
`;

const Img = styled.div`
  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 50px;
  width: 91px;
  border-radius: 8px;
  position: relative;
`;

const Label = styled.div`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 130%;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 238px;
`;

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: inherit;
  justify-content: center;
  max-width: 238px;
  overflow: hidden;
`;

const TagPremier = styled.img`
  height: 14px;
  width: 14px;
  position: absolute;
  top: -6px;
  right: -6px;
`;

export { ContentLayout, Img, Label, DescriptionContainer, TagPremier };
